export default __webpack_public_path__ + "static/media/icon-car.f3d52efd.svg";